<template>
  <div>
    <div class="logo-image"></div>
    <div class="md-layout text-center">
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-card>
          <md-card-content>
            <div>
              <h4 class="bold-header center-content">
                It's been great having you!
              </h4>
              <div>
                <h4 style="text-align: center">The {{ $store.state.activeEnvironment.name }} Partner Zone has
                been terminated</h4>
                <!--<md-card>
                  <md-card-content>
                    <div style="text-align: center">
                      <div>
                        <h5 style="margin-top: 0;">We would very much appreciate your feedback</h5>
                      </div>
                      <textarea
                        v-model="feedbackText"
                        class="feedback-input"
                      ></textarea>
                    </div>
                  </md-card-content>
                  <div style="text-align: right">
                    <md-button
                      class="feedback-button-filled"
                      @click="sendFeedback"
                      >Send</md-button
                    >
                  </div>
                </md-card>-->
                <md-card v-if="this.$store.state.environments.length > 0">
                  <md-card-header class="md-card-header-icon">
                    <h4 class="title">
                      You are free to use any of the other Partner Zones
                    </h4>
                  </md-card-header>
                  <md-card-content>
                    <div class="md-layout-item md-medium-size-50">
                      <div
                        v-for="(environment, index) in this.$store.state
                          .environments"
                        :key="index + '-environment'"
                        class="change-pz"
                      >
                        <a v-on:click="setActiveEnvironment(environment.id)">
                          <md-icon>keyboard_arrow_right</md-icon>
                          <span>{{ environment.name }}</span>
                        </a>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import UserService from "@/services/UserService";
import FeedbackService from "@/services/FeedbackService";

export default {
  components: {},
  data() {
    return {
      selectedFace: "",
      selectedCategory: "",
      feedbackText: "",
      };
  },
  mounted() {
    document.documentElement.style.setProperty(
      "--pz-background-image-url",
      "url(/img/background.jpg)"
    );
    document.documentElement.style.setProperty(
      "--pz-logo-image-url",
      "url(/img/logo-default.png)"
    );
    document.documentElement.style.setProperty(
      "--pz-logo-image-background-position-y",
      "bottom"
    );
  },
  methods: {
    async setActiveEnvironment(environment) {
      await UserService.SetUserEnvironment(environment);

      this.$store.commit("clearCart");
      this.$store.commit("clearFilters");
      this.$store.commit("setSearchString", "");
      this.$store.commit("setSearchList", "");

      window.location.href = "/";
    },
    async sendFeedback() {
      if (this.selectedFace == "" && this.feedbackText == "") {
        return;
      }
      await FeedbackService.SendFeedback({
        face: this.selectedFace,
        category: this.selectedCategory,
        text: this.feedbackText,
      });

      this.selectedCategory = "";
      this.feedbackText = "";
      this.selectedFace = "";
      this.notifyVue("Thank you for the feedback!");
      this.toggleFeedback();
    },
    getFaceClasses(face) {
      if (this.selectedFace == face) {
        return "feedback-face feedback-selected-face";
      }

      return "feedback-face feedback-unselected-face";
    },
    setSelectedFace(face) {
      this.selectedFace = face;
    },
    getCategoryClasses(category) {
      if (this.selectedCategory == category) {
        return "md-sm feedback-button-selected";
      }

      return "md-sm feedback-button";
    },
    setSelectedCategory(category) {
      this.selectedCategory = category;
    },
  },
};
</script>
<style scoped>
.center-content {
  text-align: center;
}
.bold-header {
  font-weight: 600;
}

.logo-image {
  margin-left: 30px;
  padding-top: 30px;
}

.feedback-input {
  width: 90%;
  height: 120px;
  resize: none;
}
.feedback-selected-face i {
    color: var(--pz-button-primary-color) !important;
}

.feedback-selected-face i:hover {
    color: var(--pz-button-primary-color) !important;
}

.feedback-face i {
    font-size: 48px !important;
    border-radius: 50%;
    width: 50px;
    color: var(--pz-button-primary-color) !important;
    cursor: pointer;
}

.feedback-unselected-face i:hover {
    color: var(--pz-iconbox-color) !important;
}

.feedback-unselected-face i {
    color: #ccc !important;
}

</style>
